<template>
    <div>
        <ScrollPanel ref="scrollPanel" class="custom-dialog__panel" :id="`consent${consentTextId}`">
            <div v-html="consentText"></div>
        </ScrollPanel>

        <nav class="custom-dialog__nav">
            <div class="custom-dialog__checkbox">
                <Checkbox v-model="accepted" :binary="true" :disabled="!hasReadText"
                    :inputId="`accept${consentTextId}`" />
                <label :for="`accept${consentTextId}`"> {{ labelText }}</label>
            </div>
            <Button class="p-button-primary p-button-sm" @click="handleAccept" :disabled="!accepted || !hasReadText">{{
            buttonText }}</Button>
        </nav>
    </div>
</template>
<script>
import { inject } from 'vue';
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox';
import ScrollPanel from 'primevue/scrollpanel';
let scrollTimer;
export default {
    name: "consentDialogContent",
    components: {
        Button,
        Checkbox,
        ScrollPanel
    },
    data() {
        return {
            accepted: false,
            hasReadText: false,
            consentText: null,
            consentTextId: null,
            dialogRef: null,
            labelText: null,
            buttonText: null
        }
    },
    mounted() {
        this.dialogRef = inject('dialogRef');
        this.consentText = this.dialogRef.data.consentText;
        this.consentTextId = this.dialogRef.data.consentTextId;
        this.labelText = this.dialogRef.data.labelText;
        this.buttonText = this.dialogRef.data.buttonText;
    },
    updated() {
        const scrollPanel = this.$refs.scrollPanel.$el.querySelector('.p-scrollpanel-content');
        scrollPanel.removeEventListener('scroll', this.monitorScroll);

        if (this.hasPanelReachedBottom(scrollPanel)) {
            this.hasReadText = true;
        } else {
            this.hasReadText = false;
            scrollPanel.addEventListener('scroll', this.monitorScroll);
        }

    },
    methods: {
        monitorScroll(e) {
            const vm = this;
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => {
                //If we are at the bottom, set the flag and remove the listener
                if (vm.hasPanelReachedBottom(e.target)) {
                    vm.hasReadText = true;
                    e.target.removeEventListener('scroll', vm.monitorScroll);
                }
            }, 100)
        },
        hasPanelReachedBottom(panel) {
            const distanceToBottom = (panel.scrollTop + panel.offsetHeight) - panel.scrollHeight;
            return distanceToBottom > -5 && distanceToBottom < 5; //We have a small margin here for a more friendly experience
        },
        handleAccept() {
            this.dialogRef.close({ accepted: true, consentTextId: this.consentTextId })
        }
    }
};
</script>
